import { MappingItem } from '@corratech/pylot-gtm/src/GTM'
import { upSellPromotionItemMapping } from 'stores/ooka_uae_store/components/OOKA/pylot-gtm/src/mapping/events/upSellPromotionItemMapping'
import { upSellPromotionCartItemMapping } from 'stores/ooka_uae_store/components/OOKA/pylot-gtm/src/mapping/events/upSellPromotionCartItemMapping'

export const upSellPromotionData = (
    itemMapping = upSellPromotionItemMapping(),
    cartItemMapping = upSellPromotionCartItemMapping()
): MappingItem => {
    return {
        upsell_products_view: {
            data_source: ['upsell_products'],
            mapping: itemMapping,
            strict: true
        },
        upsell_products_add: {
            data_source: ['upsell_products'],
            mapping: cartItemMapping,
            strict: true
        }
    }
}
